import React, { useState } from "react";
import { Bell, Send, Loader2, Calendar } from "lucide-react";
import { Button } from "./ui/button";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminReminders = () => {
  const [previewing, setPreviewing] = useState(false);
  const [sending, setSending] = useState(false);
  const [preview, setPreview] = useState(null);
  const [result, setResult] = useState(null);

  const fetchPreview = async () => {
    setPreviewing(true);
    try {
      const token = localStorage.getItem("tika_admin_token");
      const res = await axios.get(`${API}/admin/upcoming-reminders`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPreview(res.data);
    } catch (err) {
      toast.error("Erreur lors du chargement");
    } finally {
      setPreviewing(false);
    }
  };

  const sendReminders = async () => {
    setSending(true);
    try {
      const token = localStorage.getItem("tika_admin_token");
      const res = await axios.post(`${API}/admin/send-reminders`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setResult(res.data);
      toast.success(res.data.message);
    } catch (err) {
      toast.error("Erreur lors de l'envoi des rappels");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="space-y-4" data-testid="admin-reminders">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Bell className="w-5 h-5 text-primary" />
          <h3 className="font-semibold">Rappels J-1</h3>
        </div>
        <Button variant="outline" size="sm" onClick={fetchPreview} disabled={previewing}>
          {previewing ? <Loader2 className="w-3 h-3 animate-spin mr-1" /> : <Calendar className="w-3 h-3 mr-1" />}
          Voir événements demain
        </Button>
      </div>

      <p className="text-xs text-muted-foreground">
        Envoyez un email de rappel avec QR code aux détenteurs de billets pour les événements ayant lieu demain.
      </p>

      {preview && (
        <div className="glass-card rounded-lg p-4 space-y-3">
          {preview.total_events === 0 ? (
            <p className="text-sm text-muted-foreground text-center py-4">Aucun événement demain</p>
          ) : (
            <>
              <p className="text-sm font-medium">{preview.total_events} événement(s) demain :</p>
              <div className="space-y-2">
                {preview.events.map((ev) => (
                  <div key={ev.event_id} className="flex items-center justify-between p-2 bg-muted/20 rounded">
                    <div>
                      <p className="text-sm font-medium">{ev.title}</p>
                      <p className="text-xs text-muted-foreground">{ev.date} - {ev.venue}</p>
                    </div>
                    <span className="text-xs bg-primary/20 text-primary px-2 py-1 rounded">
                      {ev.orders_to_notify} à notifier
                    </span>
                  </div>
                ))}
              </div>
              <Button
                className="w-full"
                onClick={sendReminders}
                disabled={sending}
                data-testid="send-reminders-btn"
              >
                {sending ? (
                  <><Loader2 className="w-4 h-4 animate-spin mr-2" />Envoi en cours...</>
                ) : (
                  <><Send className="w-4 h-4 mr-2" />Envoyer les rappels</>
                )}
              </Button>
            </>
          )}
        </div>
      )}

      {result && (
        <div className="glass-card rounded-lg p-4 bg-green-500/5 border border-green-500/20">
          <p className="text-sm text-green-400 font-medium">{result.message}</p>
          <p className="text-xs text-muted-foreground mt-1">
            {result.reminders_sent} rappel(s) envoyé(s) pour {result.events_processed} événement(s)
          </p>
          {result.details && result.details.map((d, i) => (
            <p key={i} className="text-xs text-muted-foreground mt-1">
              - {d.title}: {d.reminders_sent} envoyé(s)
            </p>
          ))}
        </div>
      )}
    </div>
  );
};
